import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TextInputControl } from 'src/app/form-controls/text-input/text-input.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { ColdCompressActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface ColdCompressActionFormGroup {
	timeKeptOn: FormControl<string | null>;
}

@Component({
    selector: 'app-cold-compress-action-controls-v2',
    templateUrl: './cold-compress-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './cold-compress-action-controls-v2.component.scss'],
    imports: [ReactiveFormsModule, TextInputControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColdCompressActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: ColdCompressActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as ColdCompressActionV2;
	}

	@Input() form!: FormGroup<ColdCompressActionFormGroup>;
	@Input() item!: Row | null;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('timeKeptOn', this.formBuilder.control(this.action?.timeKeptOn ?? null));
	}
}